import styled from 'styled-components';

const base = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: scroll;
  height: 20rem;
`;
interface Irow {
  margin?: string;
}
const row = styled.div<Irow>`
  margin: ${(props) => (props.margin ? props.margin : ': 0.25rem 0')};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
`;

const info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 20%;
  margin-right: 5%;
  overflow: hidden;
`;
interface IinfoCustom {
  width?: string;
  margin?: string;
  padding?: string;
}

const infoCustom = styled(info)<IinfoCustom>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: ${(props) => (props.width ? props.width : 'auto')};
  margin: ${(props) => (props.margin ? props.margin : '0')};
  padding: ${(props) => (props.padding ? props.padding : '0 15px')};
  overflow: hidden;
`;

const documents = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
`;

const list = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const loading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20% 0;
`;

const divider = styled.div`
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
  border-bottom: 2px solid #414042aa;
`;

const title = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #115c5b;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`;

const Wrapper = {
  Base: base,
  Row: row,
  Divider: divider,
  Info: info,
  Infocustom: infoCustom,
  Title: title,
  Documents: documents,
  List: list,
  Loading: loading,
};

export default Wrapper;
